<template>

  <div ref="tbody">

    <!-- TOOLBAR -->
    <v-layout wrap class="toolbar">
      <v-flex xs12 sm6 md8>

        <slot name="toolbar"></slot>

        <v-btn icon @click="grid = !grid">
          <v-icon>{{ grid ? "view_stream" : "apps" }}</v-icon>
        </v-btn>

        <v-btn small icon @click="rescaleColumns">
          <v-icon>settings_ethernet</v-icon>
        </v-btn>

        <v-btn
        flat icon @click="infiniteMode = !infiniteMode">
          <v-icon>{{ infiniteMode ? 'check_box' : 'check_box_outline_blank' }}</v-icon>
        </v-btn>

        <v-btn
        flat icon @click="draggable = !draggable" color="green">
          <v-icon>{{ draggable ? 'check_box' : 'check_box_outline_blank' }}</v-icon>
        </v-btn>

        <v-menu offset-y>
          <v-btn slot="activator" icon>
            <v-icon>sort_by_alpha</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile v-for="(item, index) in sortOptions" :key="index" @click="localActiveSortOption = index">
              <v-list-tile-title :class="{ 'primary--text' : index == localActiveSortOption}">{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

      </v-flex>

      <v-flex xs12 sm6 md4>
        <v-text-field
        color="primary"
        spellcheck="false"
        placeholder="Search.."
        hide-details
        single-line
        solo
        clearable
        prepend-inner-icon="search"
        v-model="search"
        :suffix="`${filteredItems.length} items`"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <!-- table div -->
    <div class="table-div">

      <!-- HEADER ROW -->
      <div class="c-flex clist-header-row unselectable" ref="headerRow">
        <div class="c-inline-flex" ref="rowToolbarLeft">
          <div v-if="draggable" style="width: 24px;" class="clist-inline-block">
          </div>
          <div class="clist-inline-block clist-avatar">
          </div>
        </div>
        <div 
        v-for="(header, index) in headers" 
        :key="index"
        @mousedown="startDrag(index, $event)"
        @mouseup="stopDrag(index, $event)"
        class="clist-cell clist-header-cell">
          {{ header }}
        </div>
        <div class="c-inline-flex" ref="rowToolbarRight">
        </div>
      </div>

      <!-- END TOOLBAR -->

      <!-- IF SEARCH RESULTS EMPTY -->
      <v-card v-if="search && filteredItems.length === 0 && items.length > 0" class="subheading">
        <v-card-text>
          <v-layout align-center>
            <v-icon large color="teal lighten-1">search</v-icon>
            No items match your search term
          </v-layout>
        </v-card-text>
      </v-card>

      <!--
      <RecycleScroller
      class="scroller"
      :items="filteredItems"
      :item-height="72"
    >
      <div slot-scope="{ item }" class="user">
        <slot 
        name="list-card"
        :query="search"
        :item="item">
        </slot>
      </div>
    </RecycleScroller>
    -->

        <!--
        <DynamicScroller
        :items="filteredItems"
        min-item-height="54"
        class="scroller">

          <template slot-scope="{item, index, active}">
            <DynamicScrollerItem
            :item="item"
            :active="active"
            :size-dependencies="[item]"
            :data-index="index">

            <slot 
            name="list-card"
            :query="search"
            :item="item">
            </slot>


            </DynamicScrollerItem>
          </template>
        </DynamicScroller>
        -->        

      <template v-if="infiniteMode">
        
          <draggable
          v-if="draggable"
          :style="draggableStyle"
          v-model="filteredItems" 
          :options="{handle:'.drag-handle'}"
          class="draggable-component">

            <virtual-list 
            :size="64" 
            :remain="8" 
            :bench="6"
            class="virtual-list">

              <div xs12 :class="['list-card', {'md4 sm6': grid}]" v-for="item in filteredItems" :key="item.id || item">
                
                <v-icon class="drag-handle">drag_indicator</v-icon>

                <div style="flex: 1; display: flex;">

                  <slot 
                  v-if="grid"
                  name="grid-card"
                  :query="search" 
                  :item="item">
                  </slot>
                  
                  
                  <slot 
                  v-else
                  name="list-card"
                  :query="search"
                  :widthOverrides="widthOverrides"
                  :item="item">
                  </slot>

                </div>
                
                <v-menu class="more-button" left offset-x transition="slide-x-transition">
                    <v-icon slot="activator">more</v-icon>

                  <v-layout pa-1 style="background: white;">
                    <v-icon>delete</v-icon>
                    <v-icon>delete</v-icon>
                    <v-icon>delete</v-icon>
                    <v-icon>delete</v-icon>
                  </v-layout>
                </v-menu>

              </div>

            </virtual-list>
          </draggable>

          <virtual-list 
          v-else
          :size="48" 
          :remain="8" 
          :bench="6"
          class="virtual-list">

            <div xs12 :class="['list-card', {'md4 sm6': grid}]" v-for="item in filteredItems" :key="item.id || item">
              
              <v-icon class="drag-handle">drag_indicator</v-icon>

              <div style="flex: 1; display: flex;">

                <slot 
                v-if="grid"
                name="grid-card"
                :query="search" 
                :item="item">
                </slot>
                
                
                <slot 
                v-else
                name="list-card"
                :query="search"
                :widthOverrides="widthOverrides"
                :item="item">
                </slot>

              </div>
              
              <v-menu left offset-x transition="slide-x-transition">
                  <v-icon slot="activator">more</v-icon>

                <v-layout pa-1 style="background: white;">
                  <v-icon>delete</v-icon>
                  <v-icon>delete</v-icon>
                  <v-icon>delete</v-icon>
                  <v-icon>delete</v-icon>
                </v-layout>
              </v-menu>

            </div>

          </virtual-list>



      </template>

      <template v-else>

        <div class="clist-border-top" :style="draggableStyle">

          <div :class="['list-card', {'md4 sm6': grid}]" v-for="item in paginatedArray" :key="item.id || item">
              
              <v-icon class="drag-handle">drag_indicator</v-icon>

              <div class="c-flex c-align-center">
                <v-avatar color="grey lighten-5">
                  <v-icon>radio_button_unchecked</v-icon>
                  <img src="@/assets/img/illustrations/palette.png" alt="cardboard box">
                </v-avatar>
              </div>

              <v-menu left offset-x transition="slide-x-transition" class="more-button">
                  <v-icon slot="activator">more</v-icon>

                <v-layout pa-1 style="background: white;">
                  <v-icon>delete</v-icon>
                  <v-icon>delete</v-icon>
                  <v-icon>delete</v-icon>
                  <v-icon>delete</v-icon>
                </v-layout>
              </v-menu>

              <div style="flex: 1; display: flex;">

                <slot 
                v-if="grid"
                name="grid-card"
                :query="search" 
                :item="item">
                </slot>
                
                
                <slot 
                v-else
                name="list-card"
                :query="search"
                :widthOverrides="widthOverrides"
                :item="item">
                </slot>

              </div>
              
              

            </div>

          </div>
      </template>

      <!-- LIST ITERATION -->

      <!--
      <v-layout wrap>

        <v-flex xs12 :class="{'md4 sm6': grid}" v-for="(item, index) in paginatedArray" :key="index">
          <div class="list-card">

            <slot 
            v-if="grid"
            name="grid-card"
            :query="search" 
            :item="item">
            </slot>

            <slot 
            v-else
            name="list-card"
            :query="search"
            :item="item">
            </slot>

          </div>
        </v-flex>


      </v-layout>
      -->
      <!-- END LIST ITERATION -->

      <!-- IF LIST EMPTY -->
      <v-card v-if="items.length === 0" class="subheading">
        <v-card-text>
          <v-layout align-center>
            <v-icon large color="teal accent-4">check</v-icon>
            No items (make this a custom slot)
          </v-layout>
        </v-card-text>
      </v-card>

    </div>
    <!-- end table div -->

     <!-- PAGINATION -->
    <div class="text-xs-center" v-if="filteredItems.length > itemsPerPage && !infiniteMode">
      <v-pagination :length="paginationLength" v-model="page" circle></v-pagination>
    </div>

  </div>
  
</template>

<script>
import Vue from 'vue'
import Draggable from 'vuedraggable'

export default {
  components: {
    Draggable
  },
  props: {
    headers: {
      type: Array,
      default: function () {
        return ['Column 1', 'Column 2', 'Column 3']
      }
    },
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    activeSortOption: {
      type: Number,
      default: 0
    },
    sortOptions: {
      type: Array,
      default: null
    },
    sort: {
      type: Function,
      default: function (sortOption, items) {
        return items
      }
    },
    filter: {
      type: Function,
      default: function (sortedItems, search) {
        /* DEFAULT
        var keywords =  (search || '').toLowerCase().split(' ')
        return sortedItems.filter(item => {
          return keywords.every(keyword => {
            return (item.name + item.description).toLowerCase().indexOf(keyword) > -1
          })
        }) */
        return sortedItems
      }
    },
    draggable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      infiniteMode: false,
      grid: false,
      localActiveSortOption: this.activeSortOption,
      search: '',
      page: 1,
      itemsPerPage: 10,
      widthOverrides: [],
      drag: {
        dragging: false,
        startX: 0,
        startWidth: 0,
        index: null
      },
      draggableStyle: ''
    }
  },
  computed: {
    sortedItems () {
      return this.sort(this.localActiveSortOption, this.items)
    },
    filteredItems () {
      return this.filter(this.sortedItems, this.search)
    },
    paginatedArray () {
      var index = (this.page - 1) * this.itemsPerPage
      return this.filteredItems.slice(index, index + this.itemsPerPage)
    },
    paginationLength () {
      return Math.ceil(this.filteredItems.length / this.itemsPerPage)
    }
  },
  watch: {
    search: function (val) {
      this.page = 1
    },
    widthOverrides (nv) {
      var totalWidth = 0
      nv.forEach((width, position) => {
        totalWidth += width
        var cell = this.$refs.headerRow.children[position + 1]
        if (cell) {
          cell.style.flexBasis = width + 'px'
        }
      })
      this.draggableStyle = {
        width: totalWidth + this.$refs.rowToolbarRight.clientWidth + this.$refs.rowToolbarLeft.clientWidth + 'px'
      }
    }
  },
  methods: {
    onSortStart (event) {
      // empty
    },
    rescaleColumns () {
      this.$nextTick(() => {
        var minWidth = 120
        var maxWidth = 2000
        var toolrackWidth = this.$refs.rowToolbarRight.clientWidth + this.$refs.rowToolbarLeft.clientWidth
        var cellSize = (this.$refs.tbody.clientWidth - toolrackWidth) / this.headers.length
        if (cellSize < minWidth) {
          cellSize = minWidth
        }
        if (cellSize > maxWidth) {
          cellSize = maxWidth
        }
        this.widthOverrides = []
        for (var index in this.headers) {
          Vue.set(this.widthOverrides, index, cellSize)
        }
      })
    },
    onMouseMove (e) {
      if (this.drag.dragging) {
        var difference = this.drag.startWidth + (e.pageX - this.drag.startX)
        if (difference < 20) { // minimum cell width (should be positive)
          difference = 20
        }
        Vue.set(this.widthOverrides, this.drag.index, difference)
      }
    },
    startDrag (index, e) {
      this.drag.dragging = true
      this.drag.index = index
      this.drag.startX = e.pageX
      var cell = e.currentTarget
      this.drag.startWidth = cell.clientWidth
    },
    stopDrag (index, e) {
      this.drag.dragging = false
      this.drag.index = null
    }
  },
  created () {
    this.rescaleColumns()
    window.addEventListener('mouseup', this.stopDrag)
    window.addEventListener('mousemove', this.onMouseMove)
  }
}
</script>

<style scoped>
.more-button {
  position: sticky;
  left: 0;
  align-self: center;
}
.table-div {
  overflow-x: auto;
}
.list-nowrap {
  white-space: nowrap;
}
.clist-header-row {
  color: #B0BEC5;
  font-weight: bold;
}
.clist-inline-block {
  display: inline-block;
}
.clist-border-top {
  border-top: 3px solid rgb(243, 246, 248);
}
.virtual-list {
  border-top: 3px solid rgb(243, 246, 248);
  border-bottom: thin solid #f1f2fa;
  overflow-x: hidden;
  /* box-shadow: inset 2px 2px 5px 0px rgb(243, 246, 248); */
}
.list-card {
  cursor: pointer;
  display: flex;
  position: relative;
  /* border: thin solid rgba(0,0,0,0.05);
  padding: 10px;
  box-shadow: 2px 2px 5px 0px rgb(243, 246, 248);
  border-radius: 5px;
  margin-bottom: 4px; */
  min-height: 64px;
  border-bottom: 1px solid rgb(245, 248, 250);
}
.list-card:hover {
  background: #f3f6f8;
}
.scroller {
  height: 500px;
}
.toolbar {
}
.drag-handle {
  cursor: move;
}
.clist-header-cell {
  cursor: w-resize;
  border-right: thin solid rgba(0,0,0,0.1);
}
.clist-header-cell:hover {
  color: #555;
  background: rgb(243, 246, 248);
  /* box-shadow: inset 1px 0px #00d200, inset -1px 0px #00d200, inset 0px -1px #00d200; */
}
div ::v-deep .crx-input::before {
  content: none;
}
</style>

